import type {
  SerializableVector3,
  SurfaceDragArea,
} from "@project/emerge-types";

/**
 * Union bounding box of several surface drag areas. Each axis considers both
 * `bounds.min` and `bounds.max` of every area so reversed min/max (common on
 * side-specific axes) still contribute their full extent.
 */
export function unionSurfaceAreaBounds(
  areas: Pick<SurfaceDragArea, "bounds">[],
): { min: SerializableVector3; max: SerializableVector3 } {
  const unionMin: SerializableVector3 = [
    Number.POSITIVE_INFINITY,
    Number.POSITIVE_INFINITY,
    Number.POSITIVE_INFINITY,
  ];
  const unionMax: SerializableVector3 = [
    Number.NEGATIVE_INFINITY,
    Number.NEGATIVE_INFINITY,
    Number.NEGATIVE_INFINITY,
  ];

  for (const area of areas) {
    for (const axis of [0, 1, 2] as const) {
      const lo = area.bounds.min[axis];
      const hi = area.bounds.max[axis];
      unionMin[axis] = Math.min(unionMin[axis], lo, hi);
      unionMax[axis] = Math.max(unionMax[axis], lo, hi);
    }
  }

  return { min: unionMin, max: unionMax };
}
